import { useMetricsTimeFilter } from '~/modules/analytics';
import { useMemo } from 'react';

interface UseReportDateTimeProps {
  hasCampaignFilter?: boolean;
}

export const useReportDateTime = ({ hasCampaignFilter }: UseReportDateTimeProps) => {
  const { currentDates, compareCurrentDates } = useMetricsTimeFilter();

  const data = useMemo(() => {
    if (hasCampaignFilter && currentDates.alias !== 'custom') {
      return { currentDates, compareCurrentDates };
    }

    return {
      currentDates: {
        ...currentDates,
        startDate: currentDates.startDate.startOf('day'),
        endDate: currentDates.endDate.endOf('day'),
        versionId: currentDates.versionId,
      },
      compareCurrentDates: compareCurrentDates
        ? {
            ...compareCurrentDates,
            startDate: compareCurrentDates.startDate.startOf('day'),
            endDate: compareCurrentDates.endDate.endOf('day'),
          }
        : compareCurrentDates,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compareCurrentDates, hasCampaignFilter]);

  return data;
};
